import { Component, ViewChild, AfterViewInit, inject, ChangeDetectorRef } from '@angular/core';
import { columnModel } from '../../../components/table/model/columnModel';
import { tableModel } from '../../../components/table/model/tableModel';
import { TableComponent } from '../../../components/table/table.component';
import { Router } from '@angular/router';
import { ListConfigurationService } from '../../../services/list-configuration.service';
import { ParameterGroupService } from '../../../services/parameters.service';
import { MatExpansionPanel } from '@angular/material/expansion';
import { FilterParameterGroup } from '../../../models/filters/filter-parameter-group';
import { AlertaService } from '../../../services/alerta.service';

@Component({
  selector: 'app-parameters',
  standalone: false,
  templateUrl: './parameters.component.html',
  styleUrl: './parameters.component.css'
})
export class ParametersComponent {

 @ViewChild(TableComponent) parametesTable:TableComponent | undefined;
 @ViewChild('advancedPanel') advancedPanel!: MatExpansionPanel;

  tableModel: tableModel= {
    columnModel:[
      {columnName:'#',columnValue:'id'},
      {columnName:'Descripción',columnValue:'description'}
    ],
    dataSource:[],
    editButton:true
  };

  pageIndex: number = 1;
  pageSize: number = 5;
  loading: boolean = false;
  filterParameterGroup: FilterParameterGroup = new FilterParameterGroup;
  advancedSearch: boolean = false;

  private parameterGroupService = inject(ParameterGroupService);
  router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private alerta = inject(AlertaService);

  ngAfterViewInit() {
    //Promise.resolve().then(() =>  this.divisionsTable.initTable());
  }

  ngOnInit(): void {
    this.searchParametersPaginator();
  }

  paginatorEvent(event: any){
    this.pageIndex = (event.pageIndex+1);
    this.pageSize = event.pageSize;
    this.searchParametersPaginator();
  }
  editEvent(event: any){
    this.router.navigate(['/parameters/edit', event.id]);
  }
  searchParametersPaginatorAS(){
    this.pageIndex = 1;
    this.advancedSearch = true;
    this.searchParametersPaginator();
  }
  searchParametersPaginator(){
    this.loading = true;

    this.parameterGroupService.findAllPageableParameterGroup(this.filterParameterGroup, this.pageIndex, this.pageSize).subscribe({
      next: (pageable) => {
        this.tableModel.pageSize = pageable.pageSize;
        this.tableModel.totalRecords = pageable.itemsCount;
        this.tableModel.dataSource = pageable.list;
        this.tableModel.pageNumber = pageable.pageNum;
        
        setTimeout(() => {
          this.parametesTable?.refresh(pageable.list, pageable.itemsCount);
        });
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.loading = false;
        if(err.status == 400){
          this.alerta.error("Se ha terminado el tiempo de session: ", {detail: err.message});
          this.router.navigate(['/login']);
        }else{
          this.alerta.error("Se ha precentado un error interno: ", {detail: err.message});
        }
      }
    });

    if(this.advancedPanel != null){
      if (this.advancedSearch) {
        this.advancedPanel.open();
      } else {
        this.advancedPanel.close();
      }
    }
  }

}
